import React from "react";

export default function QuantityInput(props){

    const{label, placeholder, inputName, err, quantityRequired,quantityMin, register, value} = (props) = props;

    return(
        <fieldset className="col-12 col-md-6">
            <label className="label-element">{label}</label>
            <input className={err?"input-info error":"input-info success"}
                   defaultValue = {value}
                   name={inputName}
                   type="number"
                   min={0}
                   placeholder={placeholder}
                   {...register(inputName, { required: true, min: 0 })} />
            <div className={"error-message text-danger"}>
                {err?.type === 'required' && quantityRequired}
                {err?.type === 'min' && quantityMin}
            </div>

        </fieldset>
    )
}